<template>
  <div class="tabber">
    <div class="left">
      <div class="logo">
        <img :src="require('@/assets/logo.png')" alt srcset />
      </div>
      <div class="title">星环云智能</div>
    </div>
    <div class="right">
      <div
        v-for="(item, index) in tabberList"
        :key="'tabberList' + index"
        @click="tabberClick(item.path)"
        :class="$route.path == item.path ? 'pitch' : ''"
      >
        <div>
          {{ item.title }}
          <div class="selector-item">
            <div class="selector-item-left"></div>
            <div class="selector-item-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-2">
      <div class="icon" @click="iconClick">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabberList: [
        { title: "首页", path: "/home" },
        { title: "智慧能源", path: "/inteManufa" },
        { title: "人工智能", path: "/aipeople" },
        { title: "数字乡村", path: "/countryside" },
      ],
      tabberIndex: 0,
    };
  },
  methods: {
    tabberClick(index) {
      // this.tabberIndex = index;
      this.$emit("tabberClick", index);
    },
    iconClick() {
      this.$emit("iconClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.tabber {
  position: absolute;
  top: 0px;
  height: 100px;
  width: 100%;
  // background: linear-gradient(to bottom, #fff3, #fff0);
  //   background-color: #fff3;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fffc;
  margin-top: 20px;
  .left {
    display: flex;
    align-items: center;
    margin-left: 5vw;
    > .logo {
      //   height: 60px;
      margin-top: 5px;
      width: 80px;
      > img {
        // height: 100%;
        width: 100%;
      }
    }
    > .title {
      font-family: "ysbth";
      margin-left: 20px;
      font-size: 35px;
      height: 80px;
      line-height: 80px;
      letter-spacing: 3px;
    }
  }
  .right {
    display: flex;
    margin-right: 5vw;
    height: 100%;
    align-items: center;
    > div {
      width: 12vw;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      letter-spacing: 2px;
      > div {
        position: relative;
        .selector-item {
          position: absolute;
          bottom: -10px;
          height: 2px;
          width: 100%;
          overflow: hidden;
          .selector-item-left {
            position: absolute;
            left: -50%;
            width: 50%;
            height: 100%;
            background-color: white;
            transition: all 0.6s;
          }
          .selector-item-right {
            position: absolute;
            right: -50%;
            width: 50%;
            height: 100%;
            background-color: white;
            transition: all 0.6s;
          }
        }
      }
    }
    > div:hover {
      .selector-item-left {
        left: 0% !important;
        // animation: identifier-left 1s;
        // animation-fill-mode: forwards;
      }
      .selector-item-right {
        right: 0% !important;
        // animation: identifier-right 1s;
        // animation-fill-mode: forwards;
      }
      //   @keyframes identifier-left {
      //     form {
      //       left: -50%;
      //     }
      //     to {
      //       left: 0%;
      //     }
      //   }
      //   @keyframes identifier-right {
      //     form {
      //       right: -50%;
      //     }
      //     to {
      //         right: 0%;
      //     }
      //   }
    }
  }
  .right-2 {
    display: none;
  }
  .pitch {
    color: rgb(65, 140, 253);
  }
}

@media all and (min-width: 0px) and (max-width: 768px) {
  .tabber {
    .left {
      > .logo {
        margin-top: 5px;
        width: 10vw;
        > img {
          // height: 100%;
          width: 100%;
        }
      }
      > .title {
        font-family: "ysbth";
        margin-left: 20px;
        font-size: 4vw;
        height: 80px;
        line-height: 80px;
        letter-spacing: 3px;
      }
    }
    .right {
      display: none;
    }
    .right-2 {
      display: block;
      height: 5vw;
      width: 10vw;
      margin-right: 5vw;
      .icon {
        height: 100%;
        width: 100%;
        overflow: hidden;
        > div {
          background-color: white;
          margin-bottom: 1vw;
          height: 1vw;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tabber.vue